<header class="top-header">
  <div class="header-center-container header-left">
    <a (click)="logoNavigate()" class="logo" [attr.title]="productName">
      <svg-icon [src]="(themeService.theme$ | async)?.onBackgroundIconUrl"></svg-icon>
    </a>
  </div>
  <div class="header-center-container header-right" *ngIf="globalElementsService.showBasicLogoHeaderWithIcons$ | async">
    <button class="logo" (click)="showFeedbackModal = true">
      <svg-icon src="/assets/icons/feedback.svg"></svg-icon>
    </button>
    <button class="logo" (click)="showHelpModal = true">
      <svg-icon src="/assets/icons/question-filled-circle.svg"></svg-icon>
    </button>
  </div>
</header>

<kui-modal *ngIf="showFeedbackModal" [isOpen]="showFeedbackModal" (isOpenChange)="isFeedbackModalOpen()" type="info">
  <div class="modal-container modal-feedback">
    <kp-feedback></kp-feedback>
  </div>
</kui-modal>

<kui-modal
  *ngIf="showHelpModal"
  [analyticsData]="analyticsData"
  [isOpen]="showHelpModal"
  (isOpenChange)="isHelpModalOpen()"
  type="info">
  <div class="modal-container">
    <kp-help></kp-help>
  </div>
</kui-modal>
